import dayjs from 'dayjs';
import nl from 'dayjs/locale/nl';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { computed } from 'vue';

import { useDataFormat } from '@/composables/useDataFormat.js';
import { useFormatCurrency } from '@/composables/useFormatCurrency.js';
import { formStore } from '@/stores/form.js';
import { vragenStore } from '@/stores/vragen.js';

export function useCarDetails(voertuigStore) {
  dayjs.extend(customParseFormat);
  dayjs.locale(nl);

  const { convertToCurrency } = useFormatCurrency();
  const { capitalizeFirstLetter } = useDataFormat();

  const form = formStore();
  const vragen = vragenStore();

  const vehicleBuild = computed(() => {
    const date = voertuigStore.Bouwdatum ? new Date(voertuigStore.Bouwdatum) : false;
    return date ? dayjs(date).format('MMMM YYYY') : '';
  });

  const vehicleFuel = computed(() => {
    return voertuigStore.brandstof_soort ? voertuigStore.brandstof_soort : null;
  });

  const vehiclePower = computed(() => {
    return voertuigStore.vermogen ? voertuigStore.vermogen : null;
  });

  const vehicleWeight = computed(() => {
    return voertuigStore.gewicht ? voertuigStore.gewicht : null;
  });

  const vehicleCatValue = computed(() => {
    return voertuigStore.cataloguswaarde ? convertToCurrency(voertuigStore.cataloguswaarde) : '';
  });

  const vehicleDayValue = computed(() => {
    return voertuigStore.dagwaarde ? convertToCurrency(voertuigStore.dagwaarde) : '';
  });

  const vehiclePurchaseValue = computed(() => {
    return vragen.voertuig.Aanschafwaarde ? convertToCurrency(vragen.voertuig.Aanschafwaarde) : '';
  });

  const vehicleLicensePlate = computed(() => {
    return voertuigStore.kenteken ? voertuigStore.kenteken : '';
  });

  const vehicleBrandDetails = computed(() => {
    let values = [];
    if (vehicleBuild.value) values.push(capitalizeFirstLetter(vehicleBuild.value));
    if (vehicleFuel.value) values.push(vehicleFuel.value);
    if (vehiclePower.value) values.push(`${vehiclePower.value} KW`);
    if (vehicleWeight.value) values.push(`${vehicleWeight.value} KG`);
    return values.join(', ');
  });

  const otherVehicleTypeLink = (voertuigsoort, licencePlate) => {
    let queryString = '?prefill_kenteken=' + licencePlate.toUpperCase();
    let link = '';
    switch (voertuigsoort) {
      case 'personenauto':
      case 'bestelauto':
        link = form.links['link-auto'] + queryString;
        break;
      case 'kampeerauto':
        link = form.links['link-camper'] + queryString;
        break;
      case 'driewieligmotorvoertuig':
      case 'motorfiets':
        link = form.links['link-motor'] + queryString;
        break;
      case 'bromfiets':
      case 'snorfiets':
        link = form.links['link-bromfiets'] + queryString;
        break;
    }

    return link;
  };

  return {
    vehicleBuild,
    vehicleFuel,
    vehiclePower,
    vehicleWeight,
    vehicleCatValue,
    vehicleDayValue,
    vehicleBrandDetails,
    vehiclePurchaseValue,
    vehicleLicensePlate,
    otherVehicleTypeLink,
  };
}
